import * as React from 'react';
import { merge } from 'lodash';

import { IconProps } from './model';

const WBIcon: React.FC<IconProps> = ({ name, size, color }) => {
	return <i className={`icon-${name}`} style={merge({}, { color, fontSize: size }, iconStyle)} />;
};

const iconStyle = {
	display: 'inline-block',
	lineHeight: 0,
};

export default WBIcon;
